module.exports = __webpack_public_path__ + "img/vol06_character_thumb04.4b59c961.png";